import { gql } from "graphql-request"

export default gql`
    query ($siteId: [QueryArgument]) {
        meeting: globalSet(handle: "meeting", siteId: $siteId) {
            siteId
            ... on meeting_GlobalSet {
                isLive
                meetingName
                homeUrl: string3
                meetingStartDate: launchDate
                meetingEndDate: closingDate
                accessEndDate
                seoMetaTitle
                seoMetaDescription
                brightcovePlayerIdLive
                brightcovePlayerIdOnDemand
                googleAdsNetworkId
                ad
                adPosition
                leaderboardAdChannelsPage
                overviewOnlyProgram: lightswitchDefaultOn
                overviewOnlyAtAGlance: overviewOnlyAtAGlance
                includeDrafts: universalLightswitchOff
                pigeonholeEventPasscode
                enableFacultyProfileLinks: reusableLightswitch
                htmlAboveDirectors: html2
                showModerators
                hideTracks
                hideTracksProgram
                hideRoomsFilter
                hideRooms
                showTopics: lightswitchDefaultOff
                groupTopics
                groupRoomsFilters
                programGuideGrouping
                programColorCoding
                groupEventAtSecondLevel
                sessionTypeTerm
                trackTerm
                roomTerm
                registrationPageSlug: string
                bannerBlurb: html
                socialFooterText: string2
                hideSocialFooter
                facebookLink
                twitterLink
            }
        }
        theme: globalSet(handle: "theme", siteId: $siteId) {
            ... on theme_GlobalSet {
                colorPalette {
                    ... on colorPaletteBlock_Entry {
                        color1
                        color2
                        color3
                        color4
                        color5
                        color6
                        color7
                        color8
                        color9
                        color10
                        color11
                        color12
                        color13
                        color14
                        color15
                        color16
                    }
                }
                meetingLogo {
                    url
                }
                backgroundImage {
                    url
                }
                backgroundImageMobile {
                    url
                }
                channelsDashboardHeader {
                    url
                }
                channelsPageOnDemandBanner {
                    url
                }
                channelNavigation
                layout
                hideCrfTopBar
                contentBlock: html
                headerLockup: themeImage {
                    url
                }
                headerLockupMobile: themeImageMobile {
                    url
                }
            }
        }
        ai: globalSet(handle: "ai", siteId: $siteId) {
            ... on ai_GlobalSet {
                siteAgentId
            }
        }
        flatmenu: entries(section: "navigation", siteId: $siteId) {
            id
            title
            slug
            typeHandle
            parent(status: null) {
                id
            }
            ... on null_Entry {
                highlight
                class
                userStatus
                submenuType
                backgroundImage {
                    url
                }
                leftPanelContent
                rightPanelContent
            }
            ... on subhead_Entry {
                highlight
                class
                userStatus
            }
            ... on path_Entry {
                highlight
                class
                openInNewTab
                userStatus
                navigationPath
            }
            ... on link_Entry {
                string
                highlight
                class
                userStatus
            }
            ... on htmlPage_Entry {
                highlight
                class
                openInNewTab
                userStatus
                page {
                    slug
                }
            }
            ... on action_Entry {
                highlight
                class
                userStatus
                menuItemHandler
            }
            ... on navigation_channels_Entry {
                userStatus
                highlight
                class
            }
        }
        channels: entries(section: "channels", siteId: $siteId) {
            id
            slug
            title
            ... on channels_Entry {
                channelType
                sessionTypeID
                channelStatus
                channelDisplay
                altVideoLinksPage: page {
                    slug
                }
                videoLinksLevel
                eventListOrganization
                color1
                sponsoredBy: string3
                currentlyAvailableVersions
                brightcoveLiveStreamMediaId
                brightcovePlayerIdLive
                brightcovePlayerIdOnDemand
                isSimulive
                currentSimuliveEmbedSource
                currentPigeonholeSession
                guardLiveVersion
                guardOnDemandVersion
                specialAccessGroups: string
                adsLivePage {
                    ... on adsLivePageBlock_Entry {
                        leaderboardAd
                        sideAd1
                        sideAd2
                    }
                }
                adsOnDemandPage {
                    ... on adsOnDemandPageBlock_Entry {
                        leaderboardAd
                        sideAd1
                        sideAd2
                    }
                }
                bannerImageLive {
                    url
                }
                bannerImageOndemand {
                    url
                }
                eventListThumbnail {
                    url
                }
            }
        }
    }
`
